import axios from 'axios';

export function getCostEstimateAttachments(id)
{
    const route = '/cost-estimates/{id}/attachments';
    return axios.get(route.replace('{id}', id));
}

export function getAllFiles()
{
    return axios.get('/files');
}
